import { Fragment, FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../../../models/app-translation-keys";
import { ManageTermsOfUseDialog } from "../ManageTermsOfUseDialog/ManageTermsOfUseDialog";

export interface IAddEditTermsOfUseProps {
  isDisabled?: boolean;
  onUploadCompleted(): void;
}

const RawAddTermsOfUseButton: FunctionComponent<IAddEditTermsOfUseProps> = props => {
  const { t } = useTranslation();
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const touTranslationKeys = translationKeys.adminArea.termsOfUse;

  const handleClose = (success?: boolean) => {
    setIsDialogVisible(false);

    if (success) {
      props.onUploadCompleted();
    }
  };

  return (
    <Fragment>
      {isDialogVisible && <ManageTermsOfUseDialog isVisible={isDialogVisible} onHide={handleClose} />}

      <Button
        id="add-terms-of-use-button"
        className={classNames({ disabled: props.isDisabled })}
        onClick={() => !props.isDisabled && setIsDialogVisible(true)}
        disabled={props.isDisabled}
      >
        <FontAwesomeIcon icon={faPlus} />

        {t(touTranslationKeys.actions.create)}
      </Button>
    </Fragment>
  );
};

export const AddTermsOfUseButton = observer(RawAddTermsOfUseButton);
